import { Component, EventEmitter, input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface DialogAction {
  text: string;
  action: string;
  color?: 'primary' | 'accent' | 'warn';
  variant?: 'basic' | 'raised' | 'stroked' | 'flat';
}

export interface DialogConfig {
  title?: string;
  message?: string;
  icon?: string;
  iconColor?: string;
  allowClickOutside?: boolean;
  actions: DialogAction[];
}

@Component({
  selector: 'lfe-dialog',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css'
})
export class DialogComponent {
  config = input.required<DialogConfig>();

  @Output() actionSelected = new EventEmitter<string>();

  onActionClick(action: string) {
    this.actionSelected.emit(action);
  }

  onBackdropClick() {
    if (this.config().allowClickOutside) {
      this.actionSelected.emit('cancel');
    }
  }
}
